<template>
    <nuxt-layout>
        <nuxt-page />
    </nuxt-layout>
</template>
